/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "validate.js";
import {
  registerExternalUser,
  resetStateAuth,
} from "../../app/slices/authSlice";
import { showSnackbar } from "../../app/slices/commonSlice";
import logo from "../../assets/images/logo_black.png";
import participantCategories from "../../assets/static/participantCategories.json";
import "./Auth.css";
import { registrationSchema } from "./validationSchemas";

const RegisterExternal = () => {
  const {
    data: dataRegister,
    status: statusRegister,
    error: errorRegister,
  } = useSelector(({ auth }) => auth.register);

  const [errors, setErrors] = useState([]);
  const [formValues, setFormValues] = useState({});
  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    dispatch(resetStateAuth());

    return () => {
      dispatch(resetStateAuth());
    };
  }, []);

  useEffect(() => {
    if (dataRegister) {
      dispatch(
        showSnackbar({
          open: true,
          message:
            "Your registration request has been sent, you will receive updates through email.",
          type: "success",
        })
      );
      setFormValues({});
      dispatch(resetStateAuth());
    }
  }, [dataRegister]);

  useEffect(() => {
    if (errorRegister) {
      dispatch(
        showSnackbar({
          open: true,
          message:
            errorRegister?.message ||
            "An error occurred while registering, please try again.",
          type: "error",
        })
      );
    }
  }, [errorRegister]);

  //* methods
  const handleChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value;
    if (inputName === "phoneNumber") {
      const re = /^[0-9,+]*$/;
      if (inputValue === "" || re.test(inputValue)) {
        setFormValues({
          ...formValues,
          [inputName]: inputValue,
        });
      }
    } else if (inputName === "incorporationNumber") {
      const re = /^[a-zA-Z0-9\s.,\-/_]*$/;
      if (inputValue === "" || re.test(inputValue)) {
        setFormValues({
          ...formValues,
          [inputName]: inputValue,
        });
      }
    } else {
      setFormValues({
        ...formValues,
        [inputName]: inputValue,
      });
    }
  };

  const handleSubmit = () => {
    let _errors = validate(formValues, registrationSchema);
    if (_errors) {
      setErrors(_errors);
    } else {
      setErrors([]);

      let payload = {
        EMAIL: formValues?.email,
        FULL_NAME: formValues?.fullName,
        PHONE_NUMBER: formValues?.phoneNumber,
        REGISTERED_AS: formValues?.category,
        COMPANY_NAME: formValues?.companyName,
        INCORPORATION_NUMBER: formValues?.incorporationNumber,
      };

      dispatch(registerExternalUser(payload));
    }
  };

  //builders
  const BuildForm = () => {
    return (
      <div className="app-form p-50">
        <h2 className="mb-10">Sign Up</h2>
        <Grid container>
          <Grid item md={12} xs={12}>
            <TextField
              key={"input-email"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["email"] ? true : false}
              helperText={errors["email"] ? errors.email[0] : null}
              name="email"
              id="email"
              label="Email address"
              placeholder="email@yourdomain.ext"
              onChange={handleChange}
              value={formValues?.email || ""}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              key={"input-full-name"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["fullName"] ? true : false}
              helperText={errors["fullName"] ? errors.fullName[0] : null}
              name="fullName"
              id="fullName"
              label="Full Name"
              onChange={handleChange}
              value={formValues?.fullName || ""}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              key={"input-phone"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["phoneNumber"] ? true : false}
              helperText={errors["phoneNumber"] ? errors.phoneNumber[0] : null}
              name="phoneNumber"
              id="phoneNumber"
              label="Phone Number"
              placeholder="07XXXXXXXX"
              onChange={handleChange}
              value={formValues?.phoneNumber || ""}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              key={"input-category"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["category"] ? true : false}
              helperText={errors["category"] ? errors.category[0] : null}
              name="category"
              select
              id="category"
              label="Registering as"
              onChange={handleChange}
              value={formValues?.category || ""}
            >
              {participantCategories.map((option, index) => (
                <MenuItem
                  id={`category-${index}`}
                  key={option.title}
                  value={option.title}
                >
                  {option.title}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              key={"input-company-name"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["companyName"] ? true : false}
              helperText={errors["companyName"] ? errors.companyName[0] : null}
              name="companyName"
              id="companyName"
              label="Company Name"
              onChange={handleChange}
              value={formValues?.companyName || ""}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              key={"input-incorporation-number"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["incorporationNumber"] ? true : false}
              helperText={
                errors["incorporationNumber"]
                  ? errors.incorporationNumber[0]
                  : null
              }
              name="incorporationNumber"
              id="incorporationNumber"
              label="Incorporation Number"
              onChange={handleChange}
              value={formValues?.incorporationNumber || ""}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="flex-row mt-10 full-width justify-content-center ">
              <Button
                className="btn-login flex-row"
                variant="contained"
                onClick={handleSubmit}
                margin="dense"
                size="medium"
                disabled={statusRegister === "loading"}
              >
                {statusRegister === "loading" && (
                  <CircularProgress
                    size={20}
                    color="primary"
                    style={{ marginRight: "8px" }}
                  />
                )}
                Sign up
              </Button>
            </div>
          </Grid>
        </Grid>
        <div className="auth-link mt-20">
          Already have an account? Go back to <a href="/">sign in</a>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-row auth-container flex-wrap">
      <div className="left flex-column align-items-center justify-content-center">
        <img id="logo" src={logo} alt="Bank of Tanzania" />
        <div className="mt-10">
          <h3 className="text-align-center">
            FinTech Regulatory Sandbox Portal
          </h3>
        </div>
      </div>
      <div className="right flex-row align-items-center justify-content-center">
        {BuildForm()}
      </div>
    </div>
  );
};

export default RegisterExternal;
